import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    barColor: "rgba(0, 0, 0, .8), rgba(0, 0, 0, .8)",
    barImage: "",
    drawer: null,
    menus: null,
    navidata:null,
  },
  mutations: {
    SET_NAVI_DATA(state, payload){
      state.navidata = payload;
    },
    SET_BAR_IMAGE(state, payload) {
      state.barImage = payload;
    },
    SET_DRAWER(state, payload) {
      state.drawer = payload;
    },
    /* 机构管理 */
    SET_ORGNIZATION_PARAMS (state, params) {
      state.oganization_orgid = params.Orgid
    },
    REMOVE_ORGNIZATION_PARAMS (state) {
      state.oganization_orgid = ''
    },
    SET_ORGNIZATION_PAGE (state, params) {
      state.oganization_detail_page = params
    },
    /* APP版本更新管理 */
    SET_APP_VERSION_UPDATE_PARAMS (state, params) {
      state.versionManagement_appType = params.appType
      state.versionManagement_version = params.version
      state.versionManagement_updateFlg = params.updateFlg
      state.versionManagement_enableFlg = params.enableFlg
      state.versionDetail_id = params.id
    },
    REMOVE_APP_VERSION_UPDATE_PARAMS (state) {
      state.versionManagement_appType = ''
      state.versionManagement_version = ''
      state.versionManagement_updateFlg = ''
      state.versionManagement_enableFlg = ''
    },
    SET_APP_VERSION_UPDATE_PAGE (state, params) {
      state.versionManagement_page = params
      state.test_management_detail_class_page = params
    },
    SET_STUDENT_DETAIL_PARAMS (state, params) {
      state.versionDetail_id = params.id
    },
    /* 頁面管理 */
    SET_PAGE_MANAGEMENT_PAGEID (state, params) {
      state.pageManagementId = params.pageId
    },
    SET_PAGE_MANAGEMENT_PARAMS (state, params) {
      state.pageManagement_pageName = params.pageName
      state.pageManagement_pageUrl = params.pageUrl
      state.pageManagement_pageKnd = params.pageKnd
    },
    REMOVE_PAGE_MANAGEMENT_PARAMS (state) {
      state.pageManagement_pageName = ''
      state.pageManagement_pageUrl = ''
      state.pageManagement_pageKnd = ''
    },
    /** 课程管理 */
    SET_COURSE_MANAGER_PAGE (state, page) {
      state.courseManagement_page = page
    },
    SET_COURSE_MANAGE_PARAMS (state, params){
      state.courseManagement_trainMajorId = params.trainMajorId
      state.courseManagement_playBackFlg = params.playBackFlg
      state.courseManagement_status = params.status
      state.courseManagement_startDate = params.startDate
      state.courseManagement_endDate = params.endDate
      state.courseManagement_createName = params.createName
    },
    REMOVE_COURSE_MANAGER_PARAMS (state) {
      state.courseManagement_trainMajorId = ''
      state.courseManagement_playBackFlg =''
      state.courseManagement_status =''
      state.courseManagement_startDate = ''
      state.courseManagement_endDate =''
      state.courseManagement_createName = ''
    },
    SET_COURSE_MANAGE_DETAIL_PARAMS (state, params){
      state.courseManagement_courseId = params.courseId
    },
    REMOVE_COURSEID (state) {
      state.courseManagement_courseId = ''
    },
    /* 班级管理 */
    SET_TRAIN_CLASS_PAGE (state, params) {
      state.classManagement_page = params.page
    },
    SET_TRAIN_CLASS_PARAMS (state, params) {
      state.classManagement_trainClassName = params.trainClassName
    },
    REMOVE_TRAIN_CLASS_PARAMS (state) {
      state.classManagement_trainName = ''
    },
    // public
    SET_COURSE_MANAGEMENT_PUBLIC_COURSEID (state, params) {
      state.public_courseId = params.courseId
    },
    // public
    SET_CLASS_MANAGEMENT_PUBLIC (state, params) {
      state.public_classId = params.classId
      state.public_courseId = params.courseId
      state.public_status = params.status
    },
    SET_LESSON_ADD_COURSEID (state, params) {
      state.lesson_add_courseId = params.courseId
    },
    SET_HOMEWORK_ISSUE_PARAMS (state, params) {
      state.homework_paperId = params.paperId
      state.homework_testPaperName = params.testPaperName
    },
    SET_STUDENT_MANAGEMENT_PAGE (state, params) {
      state.student_management_page = params.page
    },
    SET_STUDENT_MANAGEMENT_PARAMS (state, params){
      state.studentManagement_classId = params.classId
      state.studentManagement_status = params.status
    },
    SET_STUDENT_ADD_PARAMS (state, params){
      state.studentAdd_userid = params.userid
      state.studentAdd_userName = params.userName
      state.studentAdd_idCardNum = params.idCardNum
      state.studentAdd_age = params.age
      state.studentAdd_sex = params.sex
      state.studentAdd_classId = params.classId
      state.studentAdd_idPhotoUrl = params.idPhotoUrl
      state.studentAdd_createTime = params.createTime
      state.studentAdd_studentId = params.studentId
      state.studentAdd_isHas = params.isHas
    },
    REMOVE_STUDENT_ADD_PARAMS (state){
      state.studentAdd_userid = ''
      state.studentAdd_studentId = ''
    },
    REMOVE_TEST_MANAGEMENT_PARAMS (state) {
      state.courseManagement_classId = ''
      state.courseManagement_testPaperType = ''
      state.courseManagement_status = ''
      state.courseManagement_startDate = ''
      state.courseManagement_endDate = ''
      state.courseManagement_createName = ''
    },
    SET_TEST_MANAGEMENT_PAGE (state, page) {
      state.test_management_page = page
    },
    SET_TEST_MANAGEMENT_PARAMS (state, params){
      state.courseManagement_classId = params.classId
      state.courseManagement_testPaperType = params.testPaperType
      state.courseManagement_status = params.status
      state.courseManagement_startDate = params.startDate
      state.courseManagement_endDate = params.endDate
      state.courseManagement_createName = params.createName
    },
    SET_TEST_MANAGEMENT_THEORY__PARAMS (state, params) {
      state.testPagerBank_testPagerId = params.testPagerId
    },
    SET_COURSE_HOMEWORK_BANK_THEORY__PARAMS (state, params) {
      state.homePager_dataPagerId = params.homePagerId
    },
    SET_COURSE_HOMEWORK_BANK_COURSE__PARAMS (state, params) {
      state.homeBank_courseId = params.courseId
    },
    REMOVE_TEST_MANAGEMENT_THEORY__PARAMS (state) {
      state.testPagerBank_testPagerId = ''
    },
    SET_TEST_MANAGEMENT_DETAIL_ACTUAL_PARAMS (state, params) {
      state.testPagerBank_actualTestPagerId = params.actualTestPagerId
    },
    REMOVE_TEST_MANAGEMENT_DETAIL_ACTUAL_PARAMS (state) {
      state.testPagerBank_actualTestPagerId = ''
    },
    // 批阅理论考试
    SET_TEST_PAPER_READ_ADD_PARAMS (state, params) {
      state.testPagerRead_studentTestPaperId = params.studentTestPaperId
    },
    // 专业管理
    SET_MAJOR_MANAGER_PARAMS(state, params){
      state.major_majorName = params.trainMajorName
    },
    // 专业管理
    REMOVE_MAJOR_MANAGER_PAGE(state){
      state.major_majorName = ''
    },
    // 课程班级-课程id
    SET_COURSE_CLASS_PARAMS (state, params) {
      state.courseClass_courseId = params.courseId
    },
    // 批阅testPaperReleaseId
    SET_REVIEW_TEST_PAPER_RELEASE_ID (state, id) {
      state.review_testPaperReleaseId = id
    },
    // 教师详情
    SET_TEACHER_DETAIL_PARAMS (state, params) {
      state.teachTeamDetail_userId = params.userId
    },
    // 账号详情
    SET_ACCOUNT_DETAIL_PARAMS (state, params) {
      state.account_userId = params.userId
      state.account_routerflg = params.routerflg
    },
    // 管理账号详情
    SET_ADMIN_DETAIL_PARAMS (state, params) {
      state.administrarors_userId = params.userid
    },
    // 机构管理
    REMOVE_ORG_MANAGER_PARAMS(state){
      state.orgManagement_name = ''
      state.orgManagement_address = ''
    },
    SET_ORG_MANAGER_PAGE(state, page){
      state.orgManagement_page = page
    },
    SET_ORG_MANAGE_PARAMS(state, params){
      state.orgManagement_name = params.name
      state.orgManagement_address = params.address
    },
    // 机构详情
    SET_ORG_MANAGE_ADD_PARAMS(state, params){
      state.orgManagement_orgAddId = params.orgId
    },
    // 删除机构ID
    REMOVE_ORGID(state){
      state.orgManagement_orgAddId = ''
    },
    // 消息
    SET_MESSAGE_PARAMS(state, params){
      state.message_messageId = params.messageId
    },
    SET_VERSION_ADD_PARAMS (state, params){
      state.versionAdd_editFlg = params.editFlg
      state.versionAdd_versionId = params.versionId
    },
    // 画面详情
    SET_PAGE_DETAIL_PARAMS (state, params) {
      state.pageManagementDetail_pageId = params.pageId
      state.pageManagementDetail_pageName = params.pageName
      state.pageManagementDetail_pageUrl = params.pageUrl
      state.pageManagementDetail_pageKnd = params.pageKnd
    },
    // 画面详情添加
    SET_PAGE_DETAIL_ADD_PARAMS (state, params) {
      state.pageManagementDetailAdd_pageId = params.pageId
      state.pageManagementDetailAdd_apiUrl = params.apiUrl
      state.pageManagementDetailAdd_apiName = params.apiName
      state.pageManagementDetailAdd_editFlg = params.editFlg
    },
    // 画面管理修改
    SET_PAGEADD_PARAMS (state, params) {
      state.pageAdd_Id= params.id
    },
    REMOVE_PAGEADD_PARAMS (state) {
      state.pageAdd_Id= ''
    },
    // 课程清单
    SET_COUESE_LIST_PARAMS (state, params) {
      state.courseList_trainMajorName = params.trainMajorName
      state.courseList_trainCourseName = params.trainCourseName
      state.courseList_trainMajorId = params.trainMajorId
    },
    REMOVE_COUESE_LIST_PARAMS (state) {
      state.courseList_trainMajorName = ''
      state.courseList_trainCourseName = ''
      state.courseList_trainMajorId = ''
    },
    SET_DISPLAY_STUDENT_DETAIL_PARAMS (state, params){
      state.displyStudentDetail_studentId = params.studentId
    },
    SET_DISPLAY_STUDENT_LIST_PARAMS (state, params){
      state.displyStudentList_trainClassId = params.trainClassId
      state.displyStudentList_trainClassName = params.trainClassName
    },
    REMOVE_DISPLAY_STUDENT_LIST_PARAMS (state){
      state.displyStudentList_trainClassId =  ''
      state.displyStudentList_trainClassName =  ''
    },
    // 章节清单
    SET_LESSON_LIST_PARAMS (state, params) {
      state.lessonList_courseId = params.courseId
      state.lessonList_trainCourseName = params.trainCourseName
    },
    REMOVE_LESSON_LIST_PARAMS (state) {
      state.lessonList_courseId = ''
      state.lessonList_trainCourseName = ''
    },
    // 章节学习清单
    SET_LESSON_LIST_DETAIL_PARAMS (state, params) {
      state.lessonListDetail_trainLessonName = params.trainLessonName
      state.lessonListDetail_playTime = params.playTime
      state.lessonListDetail_studentNum = params.studentNum
      state.lessonListDetail_lessonId = params.lessonId
    },
    // 课程详情
    SET_CLASS_MANAGE_DETAIL_PARAMS (state, params) {
      state.classManagement_classId = params.classId
    },
    REMOVE_CLASSID (state) {
      state.classManagement_classId = ''
    },
    SET_ClASS_STUDENT_SIGN_PARAMS (state, params){
      state.studentSign_classId = params.classId
      state.studentSign_signPeriod = params.signPeriod
      state.studentSign_classStatus = params.classStatus
    },
    //统计分析详情页面
    SET_VIDEO_DATA_LIST_PARAMS (state, params) {
      state.video_orgId = params
    },
    //保存页码
    SET_VIDEO_PAGE_NUM (state,pageNum) {
      state.video_pageNum = pageNum
    },
    SET_TRAIN_LESSON_ID (state, params) {
      state.classManagement_classId = params.classId
      state.classManagement_lessonId = params.lessonId
    },
    SET_ADM_CLASS_STUDENT_DETAIL (state, params) {
      state.classManagement_id = params.id
      state.classManagement_classId = params.classId
      state.classManagement_studentId = params.studentId
      state.classManagement_userInfoId = params.bbxUserInfoId
    },
    // 证书下载
    SET_STU_GRADUATION_CLASSID (state, params){
      state.stuGraduation_classId = params.classId
    },
    // 学生考试作业理论详情
    SET_STU_TEST_PAPER_THEORY_PARAMS (state, params) {
      state.stuTestPagerTheory_studentTestPaperId = params.studentTestPaperId
      state.stuTestPagerTheory_releaseId = params.releaseId
      state.stuTestPagerTheory_classId = params.classId
    },
    // 学生考试作业实操详情
    SET_STU_TEST_PAPER_PRACTICE_PARAMS (state, params) {
      state.stuTestPagerPractice_studentTestPaperId = params.studentTestPaperId
      state.stuTestPagerPractice_releaseId = params.releaseId
      state.stuTestPagerPractice_classId = params.classId
    },
  },
  actions: {},
});
